import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { SearchArticle, SearchSection, WithCounts } from "src/api/search";
import { searchArticles } from "src/api/search";
import { buildQuery } from "src/newApi";

import options from "./defaultOptions";

export function useArticlesSearch(
	filters: Record<string, unknown> | null,
	page: number,
) {
	return useQuery<WithCounts<SearchSection<SearchArticle>>, Error>({
		queryKey: ["articles-search", page, filters && buildQuery(filters)],
		queryFn: () => searchArticles(filters ?? {}, { page }),
		...options,
		placeholderData: keepPreviousData,
		enabled: !!filters,
	});
}
